import { Form } from 'antd';
import { RevxRadio } from 'components';
import { RevxSvcInputNumber } from 'components/RevxSvcInputNumber';
import { RevxRadioProps } from 'components/RevxRadio';
import { JobOptionSvc, ServiceOptionTypeEnum } from 'domains/jobconfigDomain';
import { Fragment, useEffect } from 'react';
import { useOneofId } from '../hook/useOneofId';
import { IOneofProps } from '../OneOfSvcs';

interface Iprops extends IOneofProps {
  svc?: JobOptionSvc;
}

const CommonOneofSvcOption = (props: Iprops) => {
  const { svc, svcDisabled, disabled } = props;

  const id = useOneofId(props);

  // Set defaultValue for INPUT options if form value is not set
  useEffect(() => {
    svc?.options?.forEach((option) => {
      if (option.type === ServiceOptionTypeEnum.INPUT && option.defaultValue) {
        const currentVal = props.form?.getFieldValue([id, option.label]);
        if (currentVal === undefined || currentVal === null || currentVal === '') {
          props.form?.setFieldsValue({
            [id]: { ...props.form?.getFieldValue(id), [option.label]: option.defaultValue },
          });
          if (props.formCache && props.formCache[id]) {
            props.formCache[id][option.label] = option.defaultValue;
          }
        }
      }
    });
  }, [svc?.options, id, props.form, props.formCache]);

  const attrRadioProps = (labelArr: string[]): RevxRadioProps => {
    return {
      disabled: svcDisabled || disabled,
      outSideRevxLayoutProps: {
        align: 'top',
        justify: 'left',
        wrap: 'wrap',
        className: 'jobconfig-jobOption-content-outSideOption-default',
        style: {
          paddingBottom: 0,
          marginTop: 10,
        },
      },
      inSideRevxLayoutProps: {
        align: 'top',
        justify: 'left',
        className: 'jobconfig-jobOption-content-inSideOption-default',
        style: {
          marginRight: 31,
        },
      },
      options:
        labelArr?.map((label) => {
          return {
            value: label,
            children: <span>{label}</span>,
          };
        }) || [],
    };
  };

  return (
    <>
      {svc?.options?.map((option) => {
        return (
          <Fragment key={`${id}-option-${option.label}`}>
            <div
              className="jobconfig-jobOption-content-label"
              style={{ margin: '0px 0 14px 0' }}
            >
              {option.label}
            </div>
            {option.type === ServiceOptionTypeEnum.RADIO && (
              <Form.Item name={[id, option.label]} noStyle>
                <RevxRadio {...attrRadioProps(option.values)} />
              </Form.Item>
            )}
            {option.type === ServiceOptionTypeEnum.INPUT && (
              <Form.Item name={[id, option.label]} noStyle>
                <RevxSvcInputNumber
                  allowLeadingDecimal
                  triggerOnBlur
                  min={0}
                  disabled={svcDisabled}
                />
              </Form.Item>
            )}
          </Fragment>
        );
      })}
    </>
  );
};

export default CommonOneofSvcOption;
